
      const [{ default: Application }, { default: environment }] = await Promise.all([
        import("./app/app.ts"),
        import("./app/config/environment.ts"),
      ]);

      Application.create(environment.APP);
    